declare const jhsapp: any;
import wx from "weixin-js-sdk";

// 扩展 WxInstance 类型
declare module 'weixin-js-sdk' {
  interface WxInstance {
    error(callback: (res: any) => void): void;
  }
}

// 获取 App 版本号
export function getAppVersion(ua?: string): string | null {
  // 优先通过 jhsapp.getAppVersion() 获取
  try {
    const version = jhsapp.getAppVersion();
    if (typeof version === 'string' && version) {
      return version;
    }
  } catch (e) {
    // 忽略异常，继续用 UA 解析
  }
  // 回退到 UA 解析
  const userAgent = ua || (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  const versionMatch = userAgent.match(/JHSApp\/(\d+\.\d+\.\d+)/i);
  return versionMatch ? versionMatch[1] : null;
}

// 版本号比较函数，返回 1 表示 v1>v2，-1 表示 v1<v2，0 表示相等
export function compareVersion(v1: string, v2: string): number {
  const s1 = v1.split('.').map(Number);
  const s2 = v2.split('.').map(Number);
  for (let i = 0; i < Math.max(s1.length, s2.length); i++) {
    const n1 = s1[i] || 0;
    const n2 = s2[i] || 0;
    if (n1 > n2) return 1;
    if (n1 < n2) return -1;
  }
  return 0;
}

// 判断当前平台是否支持分享
export function isAppShareSupported(ua?: string): boolean {
  const userAgent = ua || (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  const version = getAppVersion(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isAndroid = /Android/i.test(userAgent);
  if (!version) return false;
  if (isIOS) {
    return compareVersion(version, '3.23.11') >= 0;
  }
  if (isAndroid) {
    return compareVersion(version, '3.16.0') >= 0;
  }
  // 其他平台默认不支持
  return false;
}


/**
 * 检查用户是否在app内打开
 * @returns {Promise<boolean>} 返回是否在App内
 */
export const isinApp = async (): Promise<boolean> => {
  try {
    const version = jhsapp.getAppVersion()
    // const version = ''
    if (version) {
      return true;
    }else{
      return false;
    }
  } catch (error) {
    // console.error('检查是否在app内打开失败:', error);
    // 调试时设为true
    // return true;
    return false;
  }
}; 

/**
 * 打开APP
 * @param url 打开的URL
 */
export const launchApp = (url: string) => {
  let downloadUrl = 'https://sj.qq.com/appdetail/com.jihuanshe?&from_share=1';
  var isBlur = false;

  // 通过URL scheme来调起APP
  location.href = url;

  setTimeout(function () {
    if (!isBlur) {
      // alert("下载");
      location.href = downloadUrl;
    }
  }, 3500);

  // window 每次失去焦點
  window.onblur = function () {
    // alert("失去焦點");

    isBlur = true;
  };

  var hiddenProperty =
    "hidden" in document
      ? "hidden"
      : "webkitHidden" in document
        ? "webkitHidden"
        : "mozHidden" in document
          ? "mozHidden"
          : null;

  if (!hiddenProperty) return;

  var visibilityChangeEvent = hiddenProperty.replace(
    /hidden/i,
    "visibilitychange"
  );

  var onVisibilityChange = function () {
    if (document[hiddenProperty as keyof Document]) {
      // alert("失去焦點");
      isBlur = true;
    }
  };

  document.addEventListener(visibilityChangeEvent, onVisibilityChange);
};

  /**
   * 微信唤起APP
   *
   * @param {*} data 微信配置，接口返回
   */
  export const setWeiXin = (data: {
    appId: string;
    timestamp: string;
    nonceStr: string;
    signature: string;
    jsApiList: string[];
    openTagList: string[];
  }) => {

    try {
      console.log(data, 'setWeiXin');
      wx.config({
        debug: true,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: data.jsApiList,
        openTagList: data.openTagList,
      });
  
      wx.ready(function () {
        const btn = document.getElementById("launch-btn");
  
        if (!btn) return;
        console.log('微信环境初始化微信SDK成功')
        btn.addEventListener("launch", function (e: Event) {
          // 成功调起
          console.log("launch", (e as CustomEvent).detail, e);
        });
        btn.addEventListener("ready", function (e: Event) {
          // 准备调起
          console.log(e, "ready", (e as CustomEvent).detail);
        });
        btn.addEventListener("error", (e: ErrorEvent) => {
          // 调起失败
          console.log("fail", (e as unknown as CustomEvent).detail, e);
        });
      });
      (wx as any).error((e: any) => {
        console.error('初始化微信SDK失败', e)
      })
    } catch (error) {
      console.error('初始化微信SDK出现异常', error)
      return false
    }
  };

